import React, { useEffect, useState, useRef } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { LoginResponse } from "../../../models/index";
import _ from "lodash";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { utils } from "../../../utils/index";

const WeeklyChatNumbers = (props) => {
    const [weeklyChatNumber, setWeeklyChatNumber] = useState<any>([])
    const [refreshState, setRefreshState] = useState<any>(new Date())

    useEffect(() => {
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
    }, [])

    useEffect(() => {
        const newArray = props?.data?.map(item => ({ name: item.departmentName, y: item.totalChats }))
        setWeeklyChatNumber(newArray)
    }, [props?.data])

    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }


    const Options1 = {
        chart: {
            type: 'pie',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: ''
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                size: '60%',
                dataLabels: {
                    enabled: true,
                    format: '<span style="font-size: 1em"><b>{point.name}</b></span><br>' +
                        '<span style="opacity: 0.6">{point.y}</span>',
                    connectorColor: 'rgba(128,128,128,0.5)'
                },
                showInLegend: true
            }
        },
        series: [{
            data: weeklyChatNumber,
        }]
    }

    return (
        <div className="row wgreport-row" id="weeklyChat">
            {weeklyChatNumber?.length > 0 && <> <div className="row" >
                <div className="col-12 text-center">
                    <div className="wgreport-span">{props.heading}</div>
                </div>
            </div>

                <HighchartsReact
                    highcharts={Highcharts}
                    options={Options1}
                /></>}
        </div>
    )
}
export default WeeklyChatNumbers;